// @flow

import Resource from 'speed-js-core/src/api/Resource';


/**
 * Used only for creating/updating ODF that are not inside a PoP
 */
export default class ODFNonPoPResource extends Resource {
    basePath: string = 'networks/odfs/';

    objectPath: string = 'networks/odfs/{ident}/';
}
